function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import autoBind from 'auto-bind';
import { AsyncSubject } from 'rxjs';
import VimeoPlayer from '@vimeo/player';
import BTBaseVideoPlayer from './base';
import { VIDEO_PLAYER_VIMEO, EVENT_PLAYER_LOADED } from './index';

var BTVimeoPlayer = /*#__PURE__*/function (_BTBaseVideoPlayer) {
  _inherits(BTVimeoPlayer, _BTBaseVideoPlayer);

  var _super = _createSuper(BTVimeoPlayer);

  function BTVimeoPlayer(_ref) {
    var _this;

    var name = _ref.name,
        vimeoId = _ref.vimeoId,
        _ref$videoContainer = _ref.videoContainer,
        videoContainer = _ref$videoContainer === void 0 ? null : _ref$videoContainer,
        _ref$autoplay = _ref.autoplay,
        autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay;

    _classCallCheck(this, BTVimeoPlayer);

    _this = _super.call(this, {
      name: name
    });

    if (!vimeoId) {
      throw new Error('Missing required argument: vimeoId');
    }

    _this._vimeoId = vimeoId;
    _this._autoplay = autoplay;
    _this._videoContainer = videoContainer;
    _this._playerLoadSubject = new AsyncSubject();
    autoBind(_assertThisInitialized(_this));

    _this._init();

    return _this;
  }

  _createClass(BTVimeoPlayer, [{
    key: "playerType",
    get: function get() {
      return VIDEO_PLAYER_VIMEO;
    }
  }, {
    key: "nativePlayer",
    get: function get() {
      return this._nativePlayer;
    }
  }, {
    key: "play",
    value: function () {
      var _play = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var player;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._getPlayer();

              case 2:
                player = _context.sent;
                _context.next = 5;
                return player.play();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function play() {
        return _play.apply(this, arguments);
      }

      return play;
    }()
  }, {
    key: "pause",
    value: function () {
      var _pause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var player;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._getPlayer();

              case 2:
                player = _context2.sent;
                _context2.next = 5;
                return player.pause();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function pause() {
        return _pause.apply(this, arguments);
      }

      return pause;
    }()
  }, {
    key: "mute",
    value: function () {
      var _mute = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var player;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._getPlayer();

              case 2:
                player = _context3.sent;
                _context3.next = 5;
                return player.setVolume(0);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function mute() {
        return _mute.apply(this, arguments);
      }

      return mute;
    }()
  }, {
    key: "unmute",
    value: function () {
      var _unmute = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var player;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._getPlayer();

              case 2:
                player = _context4.sent;
                _context4.next = 5;
                return player.setVolume(1);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function unmute() {
        return _unmute.apply(this, arguments);
      }

      return unmute;
    }()
  }, {
    key: "_getPlayer",
    value: function _getPlayer() {
      var _this2 = this;

      // eslint-disable-next-line no-unused-vars
      return new Promise(function (resolve, reject) {
        _this2._playerLoadSubject.subscribe(function (_ref2) {
          var player = _ref2.player;
          resolve(player);
        });
      });
    }
  }, {
    key: "_init",
    value: function _init() {
      var _this3 = this;

      if (this._initialized) {
        throw new Error('Player is already initialized');
      }

      var iframe = document.createElement('iframe');
      iframe.id = 'video';
      iframe.src = "https://player.vimeo.com/video/".concat(this._vimeoId, "?").concat(this._autoplay && 'autoplay=1&muted=1' || '');

      if (this._autoplay) {
        iframe.allow = 'autoplay';
      }

      var videoContainer = this._videoContainer;

      if (!videoContainer) {
        videoContainer = document.getElementById('video-container');

        if (!videoContainer) {
          throw new Error('Could not find element with id=video-container');
        }
      }

      videoContainer.appendChild(iframe);
      iframe.addEventListener('load', function () {
        _this3._log('player loaded', _this3._name);

        _this3._nativePlayer = new VimeoPlayer(iframe);

        _this3._nativePlayer.on('timeupdate', function (_ref3) {
          var seconds = _ref3.seconds,
              percent = _ref3.percent,
              duration = _ref3.duration;

          _this3._playerProgressBus.next({
            seconds: seconds,
            percent: percent,
            duration: duration
          });
        });

        _this3._nativePlayer.on('play', function () {
          _this3._log('player PLAYED');
        });

        _this3._nativePlayer.on('pause', function () {
          _this3._log('player PAUSED');
        });

        _this3._playerLoadSubject.next({
          player: _this3._nativePlayer
        });

        _this3._playerLoadSubject.complete();

        _this3._eventBus.next({
          event: EVENT_PLAYER_LOADED
        });
      });
    }
  }]);

  return BTVimeoPlayer;
}(BTBaseVideoPlayer);

export { BTVimeoPlayer as default };